export default "__VITE_ASSET__25747c9b__"